<template>
  <div>
    <div
      class="btn-wrapper d-flex justify-content-md-end justify-content-center"
    >
      <button
        class="btn btn-outline-primary wizard-btn prev-btn"
        @click="input()"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>

        {{ $t("global.return") }}
      </button>
      <button
        v-show="!isHandleYes"
        id="handle_no"
        class="btn btn-primary wizard-btn next-btn"
        @click="input(false)"
      >
        {{ $t("global.next") }}
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>

      <button
        v-show="isHandleYes"
        id="handle_yes"
        class="btn btn-primary wizard-btn next-btn"
        @click="input(true)"
      >
        {{ $t("global.next") }}
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
    <div class="card card-small mb-4 mt-3">
      <div class="card-body">
        <div class="py-2 px-3" v-if="step === 0">
          <h5>{{ $t("days.off.request.step.two.title") }}</h5>
          <p class="mt-0">{{ $t("days.off.request.step.two.description") }}</p>
          <div id="isUrgentWrapper">
            <div class="custom-control custom-radio mb-3">
              <input
                type="radio"
                id="no"
                value="no"
                name="no"
                @change="isUrgent"
                v-model="checkedIsUrgent"
                class="custom-control-input"
              />
              <label class="custom-control-label" for="no">{{
                $t("global.no")
              }}</label>
            </div>

            <div class="custom-control custom-radio mb-3">
              <input
                type="radio"
                id="yes"
                value="yes"
                name="yes"
                @change="isUrgent"
                v-model="checkedIsUrgent"
                class="custom-control-input"
              />
              <label class="custom-control-label" for="yes">{{
                $t("global.yes")
              }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="p-4">
        <div class="card" v-show="isUrgentTextArea">
          <div class="card-body">
            <h5>{{ $t("days.off.request.step.two.motif") }}</h5>
            <textarea
              class="form-control mt-4"
              v-model="motif"
              cols="50"
              rows="10"
            ></textarea>
            <errors field="motifUrgent" :errors="errors"></errors>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Errors from '../../error/errors';
import ErrorsHelper from '../../../helper/ErrorsHelper';

export default {
  name: 'StepTwo',
  components: { Errors },
  data() {
    return {
      isHandleYes: false,
      checkedIsUrgent: 'no',
      isUrgentTextArea: false,
      step: 0,
      motif: null,
      errors: {},
      requiredFields: ['motifUrgent'],
    };
  },
  props: ['user'],
  methods: {
    input(obj) {
      this.errors = {};
      if (obj === undefined) {
        this.$emit('input', null);
      } else if (!obj) {
        this.$emit('input', { urgent: false });
      } else {
        const model = { urgent: true, motifUrgent: this.motif };
        if (ErrorsHelper.checkErrors(this.requiredFields, model, this.errors)) {
          this.$emit('input', model);
        }
      }
    },

    isUrgent() {
      if (this.checkedIsUrgent === 'yes') {
        this.isUrgentTextArea = true;
        this.isHandleYes = true;
      } else {
        this.isUrgentTextArea = false;
        this.isHandleYes = false;
      }
    },
  },
};
</script>

<style scoped>
.card {
  position: relative;
}
.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}
</style>
